<template>
	<div>
		<div @click="handleClick" @mousedown="toPlane" @mouseup="toDemisional" class="buttonComponent"
         :style="styleView"
         :class="[editType===2?'form-onlyRead':'']"
         v-if="realtimeData.state === true && mode==='view'">{{this.realtimeData.text}}
    </div>
		<div @click="handleClick" class="buttonComponent" :style="styleEdit" :class="[editType===2?'form-onlyRead':'']"
		v-if="mode==='edit'">{{this.realtimeData.text}}</div>
    <el-dialog :style="dialogStyle"
        title="子窗口页面"
        :visible.sync="modalShow"
        :width="realtimeData.modalValue+'px'"
        @close="modalShow=false"
        append-to-body>
      <div :style="modelStyle">
        <div style="width: 100%; ">
          <the-create style="width: 100%;" :companyId="companyId" :productId="realtimeData.pageId" :projectId="productSaveForm.projectId" :editType="3" :dialogCount="dialogCount+1" :readPublished="true"></the-create>
        </div>
      </div>
    </el-dialog>
	</div>
</template>
<script>
	import componentsMixin from "../componentsMixin";
    export default {
		name: 'buttonComponent',
		mixins: [componentsMixin],
    data() {
      return {
        boxShadow: '3px 4px 0px 0px #8a2a21'
      }
    },
		computed:{
      styleEdit() {
        let res = {...this.style};
        res['animation-play-state']='paused';
        return res;
      },
      styleView() {
        let res = {...this.style};
        res['box-shadow'] = this.boxShadow
        return res;
      },
      dialogStyle(){
        //所以现在直接用px作单位并且不减去自身的高度了
        if(this.realtimeData.modalX === undefined && this.realtimeData.modalY === undefined ){
          var applyLeft = '0'
          var applyTop = '0'
        } else if (this.realtimeData.modalX.length == 0 && this.realtimeData.modalY.length == 0){
          var applyLeft = '0'
          var applyTop = '0'
        }else if(this.realtimeData.modalX.length !== 0 && this.realtimeData.modalY.length == 0){
          var applyLeft = this.realtimeData.modalX
          var applyTop = '0'
        } else if (this.realtimeData.modalY.length !== 0 && this.realtimeData.modalX.length == 0) {
          var applyLeft = '0'
          var applyTop = this.realtimeData.modalY
        } else if (this.realtimeData.modalY.length !== 0 && this.realtimeData.modalX.length !== 0) {
          var applyLeft = this.realtimeData.modalX
          var applyTop = this.realtimeData.modalY
        }
        return {
          top:`calc(${applyTop}px + 10vh)`,
          left: applyLeft + 'px',
        }
      },
		},
    methods: {
      toPlane() {
        this.boxShadow=''
      },
      toDemisional() {
        this.boxShadow='3px 4px 0px 0px #8a2a21'
      }
		},
		watch:{
      styleView: {
        handler(val) {
          console.log("styleView改变了",val)
        }
      },
      // 'realtimeData.top': {  // x绑定
      //   handler() {
      //     this.wrapperStyle.top = this.realtimeData.top +'px'
      //   }
      // },
      // 'realtimeData.left': {  // y绑定
      //   handler() {
      //     this.wrapperStyle.left = this.realtimeData.left +'px'
      //   }
      // },
      // 'realtimeData.height': {  // 高度绑定
      //   handler() {
      //     this._style.height = this.realtimeData.height + 'px'  // componentsMixin 中对 _style 进行了检查更新style 绑定至矩形框
      //     this.wrapperStyle.height = this.realtimeData.height +'px'
      //   }
      // },
      // 'realtimeData.width': {  // 宽度绑定
      //   handler() {
      //     console.log("宽度发生改变",this.realtimeData.width,this.style)
      //     this._style.width = this.realtimeData.width + 'px'
      //     this.wrapperStyle.width = this.realtimeData.width +'px'  // 编辑框
      //   }
      // },
      'realtimeData.btnColor':{ //按钮颜色
        handler(){
          this._style["background-color"] = this.realtimeData.btnColor
        }
      },
      'realtimeData.txtSize':{ //文本字体大小
        handler(){
          this._style["font-size"] = this.realtimeData.txtSize + 'px'
        }
      },
      'realtimeData.txtStyle':{ //文本字体样式
        handler(){
          this._style["font-family"] = this.realtimeData.txtStyle
        }
      },
      'realtimeData.txtColor':{ //文本字体颜色
        handler(){
          this._style["color"] = this.realtimeData.txtColor
        }
      },
			'realtimeData.txtDecoration':{ //文本装饰
				handler(){
					this._style["text-decoration"] = this.realtimeData.txtDecoration
				}
			},
			'realtimeData.txtPosition':{ //文本位置
				handler(){
					this._style["justify-content"] = this.realtimeData.txtPosition
				}
			},
			'realtimeData.btnBorderColor':{ //按钮边框颜色
				handler(){
					this._style["border-color"] = this.realtimeData.btnBorderColor
				}
			},
    }
	}
</script>
<style lang="less" scoped>
	.form-onlyRead {
		pointer-events: none;
	}
	@keyframes twinkle {
		0% {
			opacity: 1;
		}
		50% {
			opacity: 0.5;
		}
		100% {
			opacity: 1;
		}
	}
	.buttonComponent {
		overflow: hidden;
		border-radius:18px;
		border:1px solid;
		display:flex;
		align-items: center;
		cursor:pointer;
		animation-name: twinkle;
		animation-timing-function: ease-in-out;
		animation-iteration-count:infinite;
		//&:active {
		//	position:relative;
		//	top:3px;
		//	left:4px;
		//	box-shadow:none
		//}
	}
  ::v-deep .el-dialog{
    margin:0 !important;
    position:absolute;
  }
</style>
